import { defineMessages } from 'react-intl';

export default defineMessages({
  switchRightOption: 'Borrowings',
  switchLeftOption: 'Deposits',

  depositInformation: 'Deposit Information',
  approximateBalance: 'Approximate balance',
  depositComposition: 'Deposit Composition',

  borrowInformation: 'Borrow Information',
  youBorrowed: 'You borrowed',
  yourCollateral: 'Your collateral',
  currentLTV: 'Current LTV',
  borrowingPowerUsed: 'Borrowing Power Used',
  borrowComposition: 'Borrow Composition',
  details: 'Details',

  connectWallet: 'Please connect your wallet',
  connectWalletDescription:
    'To see your deposited / borrowed assets, you need to connect your wallet.',
});
